module.exports = __webpack_public_path__ + "static/img/1260_phase_function_Paper_PointsHejduk_Prediction.5e76ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1260_phase_function_Paper_PointsHejduk_Prediction.png
// module id = tuGG
// module chunks = 0